export default __webpack_public_path__ + "054427872d9228fda5e9590ff05b5b41.png";